export var ELogsAction;
(function (ELogsAction) {
    ELogsAction["start"] = "i_start";
    ELogsAction["q_submit"] = "q_submit";
    ELogsAction["auto_q_submit"] = "auto_q_submit";
    ELogsAction["logout"] = "logout";
    ELogsAction["close_tab"] = "close_tab";
    ELogsAction["end_interview"] = "end_interview";
    ELogsAction["auto_submit_interview"] = "auto_submit_interview";
    ELogsAction["face_start"] = "face_capture_start";
    ELogsAction["f_start"] = "final_instruction_start";
    ELogsAction["result_waiting"] = "result_waiting";
    ELogsAction["speechace"] = "speechace";
})(ELogsAction || (ELogsAction = {}));
